import TechnicalValidationReviewsManager from './TechnicalValidationReviewsManager.container';

export default TechnicalValidationReviewsManager;
